export default __webpack_public_path__ + "static/contact-c81e074ee5f0fe23eada64377e76a51b.png";